module.exports = __webpack_public_path__ + "img/eBackup-background.ae45f7ea.png";